export const MINIMUM_REDEEMABLE_POINTS = 1000;
